<section class="blog blog-grid pt-70 pb-90">
    <div class="container pairblank">
        <div class="page__section">
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/']" class="href breadcrumb__point " title="Ana Sayfa">Ana Sayfa</a>
                        <span class="breadcrumb__divider" aria-hidden="true"> › </span>
                    </li>
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/stock-recommendation']" class="href breadcrumb__point " title="Hise Önerileri">Hise Önerileri</a>
                        <span class="breadcrumb__divider" aria-hidden="true"> › </span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">{{stockRecommendationList[0]?.brokerageFirm}}</span>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="row" style="padding: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <div>
                    <h1 class="info-detail-title" ><a [routerLink]="['/stock-recommendation/araci-kurum',stockRecommendationList[0]?.url]" title="Hisse Önerileri">{{stockRecommendationList[0]?.brokerageFirm}}</a></h1>
                </div>
                <div>
                    <h2 class="h5">{{stockRecommendationList[0]?.brokerageFirm}} Aracı Kurum Hisse Önerileri listesi aşağıdaki gibidir;</h2>
                </div>
                <div class="row dividend-title archive-title-style">
                    <div class="col-3">Hisse</div>
                    <div class="col-3">Tarih</div>
                    <div class="col-3">Fiyat</div>
                    <div class="col-3">Hedef Fiyatı</div>
                </div>
                <div class="div div-hover div-responsive div-striped my-2 px-2" *ngFor="let stockr of srList ; trackBy:trackByBrokerageFirm">
                <div class="row mt-2" *ngIf="srList">
                    <div class="tables col-3"><a [routerLink]="['/stock-recommendation',stockr?.code]" title="{{stockr?.code}}" style="color: blue;"><strong>{{stockr?.code}}</strong></a></div>
                     <div class="tables col">{{stockr?.finalClosingDate | date:'d MMMM y'}}</div>
                     <div class="tables col">{{stockr?.finalClosingPrice |currency:"TRY":"symbol"}}</div>
                     <div class="tables col" *ngIf="stockr?.targetPrice">{{stockr?.targetPrice|currency:"TRY":"symbol"}}</div>
                     <div class="row mt-3">
                     <p class="m-2">{{stockr?.code}} Getiri Potansiyeli :<ngb-progressbar type="success" textType="white" [value]="stockr?.percentPotential" [showValue]="true"></ngb-progressbar></p>
                     </div>
                     <hr class="hr"/>
                </div>
                </div>
                <div class="row" style="margin-top: 20px;" >
                    <div class="col-sm-12 col-md-12 col-lg-12 clearfix mt-10 text--center">
                        <app-mansel-pagination [pageIn]="pageInfo"
                            (setManselPaginePageEvent)="setPage($event)"></app-mansel-pagination>
                    </div>
                </div>
                <div class="card bg-dark mt-3 mb-3">
                    <div class="card">
                    <h5 class="card-title m-3 text-dark"><mark>Aracı Kurumunun En Yüksek Hedef Fiyat Verdiği Hisseler</mark></h5>
                <div class="card-body">
                    <p><em><strong>'{{maxValue.brokerageFirm}}'</strong></em> aracı kurumunun <mark>en yüksek</mark> hedef fiyat verdiği hisse {{maxValue.code}} olmuştur. Aracı kurumun verdiği hedef fiyat <mark>{{maxValue.targetPrice|currency:"TRY":"symbol"}}</mark> iken, hissenin bu hedef fiyatına ve son gün kapanışına göre getiri potansiyeli %{{maxValue.percentPotential}} olmuştur.
                    </p>
                    <h6 class="h5 card-title text-dark"><mark>Aracı Kurumunun - En Düşük Hedef Fiyat Verdiği Hisseler</mark></h6>
                    <p><em><strong>'{{minValue.brokerageFirm}}'</strong></em> aracı kurumunun <mark>en düşük</mark> hedef fiyat verdiği hisse {{minValue.code}} olmuştur. Aracı kurumun verdiği hedef fiyat <mark>{{minValue.targetPrice|currency:"TRY":"symbol"}}</mark> iken, hissenin bu hedef fiyatına ve son gün kapanışına göre getiri potansiyeli %{{minValue.percentPotential}} olmuştur.
                    </p>
                    <p><em><strong>'{{maxPotential.brokerageFirm}}'</strong></em> aracı kurumunun <mark>en yüksek getiri potansiyeli</mark> önerisi verdiği hisse ise {{maxPotential.code}} olmuştur. Aracı kurumun verdiği hedef fiyat {{maxPotential.targetPrice|currency:"TRY":"symbol"}} iken, hissenin bu hedef fiyatına ve son gün kapanışına göre getiri potansiyeli <mark>%{{maxPotential.percentPotential}}</mark> olmuştur.
                    </p>
                </div>
            </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-summary-recommendation></app-summary-recommendation>
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
            </div>
        </div>
    </div>
</section>
